<template>
  <p-app theme="glittr_nodesign">
    <p-container>
      <slot></slot>
    </p-container>
  </p-app>
</template>

<script>
  export default {
    data: () => ({
    }),
  };
</script>
